import { model as i18nModel } from '!/i18n'
import { api } from '@setplex/tria-api'
import { combine, type Store } from 'effector'
import { ssePurchasesModel } from '~/features/payment/sse-purchases'
import { extendMediaItemByLabelPriceTvChannel } from '~/shared/tools'
import { type CategoryWithChannelsWithPrice } from './index.h'

export const $tvCategoriesWithChannels: Store<
  CategoryWithChannelsWithPrice[] | null
> = combine(
  api.tv.$tvCategoriesWithChannels,
  ssePurchasesModel.$channel,
  i18nModel.$t,
  (newContent, adjust) => {
    if (newContent?.length === 0) return null

    return newContent
      .map((category) => {
        const tvChannel = category.content.map((channel) =>
          extendMediaItemByLabelPriceTvChannel(adjust(channel))
        )

        return {
          ...category,
          content: tvChannel,
        }
      })
      .sort((a, b) => Number(a.sortOrder) - Number(b.sortOrder))
  }
)
